import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The kit registry's retired address. A saved deep link — a receipt link a
 * tester kept, a mailed landing — still arrives here, so it lands on the
 * renamed page with whatever search params it carried.
 */
export const Route = createFileRoute("/_company/equipment")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/test-kits", search });
  },
});
